import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    id: "faq-critical-ai",
    q: "How does Harris Holt provide critical AI for the nation?",
    a: "As AI becomes a defining factor in global competitiveness, Harris Holt is committed to strengthening national AI capacity — advancing sovereign compute infrastructure, cultivating domestic talent, and delivering scalable, industrial-grade AI solutions.",
  },
  {
    id: "faq-workforce",
    q: "How does Harris Holt see the impact of AI on the workforce?",
    a: "Harris Holt views AI as a force for empowerment, not displacement. By automating repetitive tasks, enhancing decision-making, and unlocking new capabilities, we help organizations invest in reskilling and thoughtful adoption — building teams that are stronger and more capable than before.",
  },
  {
    id: "faq-responsible-ai",
    q: "How does Harris Holt ensure responsible AI?",
    a: "Harris Holt embeds governance, security, and ethical safeguards at every stage of the AI lifecycle, from initial design through deployment. This approach balances speed with responsibility, ensuring systems remain resilient, transparent, and aligned with evolving standards as the technology — and its risks — continue to evolve.",
  },
  {
    id: "faq-secure-data",
    q: "How do we secure AI data for Harris Holt customers?",
    a: "Security is foundational to how we operate. Harris Holt integrates advanced data security and privacy safeguards — to protect customer information across every stage of the AI lifecycle.",
  },
  {
    id: "faq-commercial-partners",
    q: "Does Harris Holt work with commercial partners to build AI solutions?",
    a: "Yes. Harris Holt collaborates closely with commercial technology providers and innovators to deliver best-in-class AI capabilities. We integrate, secure, and scale these solutions to ensure they translate into meaningful, measurable outcomes for our customers.",
  },
  {
    id: "faq-sovereign-cloud",
    q: "What are sovereign AI cloud services?",
    a: "Harris Holt is collaborating with partners to deliver a full spectrum of sovereign AI cloud services, encompassing AI operations in secured environments, intelligence augmentation, cyber AI, synthetic data and simulation, and seamless edge-to-cloud orchestration.",
  },
];

export const Faq = () => (
  <section id="faqs" data-testid="faq-section" className="py-24 md:py-32 px-6 md:px-12 border-t border-black/10">
    <div className="max-w-4xl mx-auto">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ type: "spring", stiffness: 60, damping: 18 }}
      >
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#0891B2] mb-4">FAQs</p>
        <h2 className="text-3xl sm:text-4xl font-heading font-bold tracking-tight text-zinc-950">
          Frequently asked questions
        </h2>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ type: "spring", stiffness: 60, damping: 18, delay: 0.1 }}
        className="mt-10"
      >
        <Accordion type="single" collapsible className="w-full">
          {faqs.map((f) => (
            <AccordionItem key={f.id} value={f.id} data-testid={f.id} className="border-b border-black/10">
              <AccordionTrigger
                data-testid={`${f.id}-trigger`}
                className="text-left font-heading font-bold tracking-tight text-zinc-950 text-xl sm:text-2xl hover:text-[#0891B2] hover:no-underline"
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent data-testid={`${f.id}-content`} className="text-[19px] leading-relaxed text-zinc-600">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </motion.div>
    </div>
  </section>
);
